import { Button, Heading, Typography } from '@altify/components';
import { useContent } from '@altify/utils';
import exclamationIcon from 'assets/icons/exclamation_outline.svg';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import { useCallback } from 'react';
import { useAcceptUserTermsMutation } from 'store/slices/termsAndConditions-api';
import { getMarketingUrl } from 'utils/app-urls';
import { content } from './BundleRebalanceTermsModal.content';
import AlertImage from '../../assets/Alert.svg';

const legalDocumentsUrl = `${getMarketingUrl()}/legal/terms-of-service`;

const BundleRebalanceTermsModal = ({
  isOpen,
  handleClose,
}: {
  isOpen: boolean;
  handleClose: (dismissed: boolean) => void;
}) => {
  const localizedContent = useContent(content);
  const bundleRebalanceTerm = 'BUNDLE_REBALANCE';

  const onChange = useCallback(
    (dismissed: boolean) => {
      handleClose?.(dismissed);
    },
    [handleClose],
  );

  const [acceptTerms, acceptTermsResult] = useAcceptUserTermsMutation();

  const acceptBundleRebalance = async () => {
    await acceptTerms(bundleRebalanceTerm);
    handleClose(true);
  };

  return (
    <DialogOrBottomSheet
      isOpen={isOpen}
      blurEnabled={true}
      onClose={() => onChange(true)}
      backgroundColor="#0C1C2C">
      <div className="flex flex-col items-center w-full my-4 px-4  gap-6">
        <img src={AlertImage} />
        <Heading level={4} className="text-center">
          {localizedContent.title}
        </Heading>
        <Typography
          weight="medium"
          size="large"
          className="text-gray text-center">
          {localizedContent.description}
          <a
            href={legalDocumentsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-normal underline  text-white">
            {localizedContent.managementeMandate}
          </a>
          {', '}
          <a
            href={legalDocumentsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-normal underline  text-white">
            {localizedContent.bundleMethodology}
          </a>
          {', '}
          <a
            href={legalDocumentsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-normal underline  text-white">
            {localizedContent.riskDisclosures}
          </a>
          {', & '}
          <a
            href={legalDocumentsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-normal underline  text-white">
            {localizedContent.generalRiskDisclosures}
          </a>
        </Typography>
        <Button
          onPress={acceptBundleRebalance}
          loading={acceptTermsResult.isLoading}
          text={localizedContent.confirmButton}
          className="w-full mt-10"
        />
      </div>
    </DialogOrBottomSheet>
  );
};

export default BundleRebalanceTermsModal;
